"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProperty = void 0;
exports.hasProperty = (object, prop) => Object.prototype.hasOwnProperty.call(object, prop);
//# sourceMappingURL=has-property.js.map